import { render, staticRenderFns } from "./Stap3b.vue?vue&type=template&id=9ee271b2&"
import script from "./Stap3b.vue?vue&type=script&lang=js&"
export * from "./Stap3b.vue?vue&type=script&lang=js&"
import style0 from "./Stap3b.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports